/*
 * OVA FAQ accordion.
 * Progressively enhances the static h3/p question-answer pairs stored in
 * the FAQ page's rich-text content (wrapped in <div class="ova-faq">) into
 * a collapsible accordion. Reads the DOM rather than requiring the page
 * content itself to change, so editing the Q&A list in Shopify admin keeps
 * working without touching this script.
 */
(function () {
  function stripLeadingNumber(text) {
    return text.replace(/^\s*\d+\.\s*/, '').trim();
  }

  function buildAccordion() {
    var source = document.querySelector('.main-page--faq .page--content .ova-faq');
    if (!source) return;

    var children = Array.prototype.slice.call(source.children);
    var list = document.createElement('div');
    list.className = 'faq-list';

    for (var i = 0; i < children.length; i++) {
      var node = children[i];
      if (node.tagName !== 'H3') continue;

      var question = stripLeadingNumber(node.textContent);
      var answerParts = [];
      var next = node.nextElementSibling;
      while (next && next.tagName !== 'H3') {
        answerParts.push(next.outerHTML);
        next = next.nextElementSibling;
      }

      var item = document.createElement('div');
      item.className = 'faq-item';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'faq-item__question';
      button.setAttribute('aria-expanded', 'false');

      var label = document.createElement('span');
      label.textContent = question;

      var icon = document.createElement('span');
      icon.className = 'faq-item__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML =
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none">' +
        '<path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
        '</svg>';

      button.appendChild(label);
      button.appendChild(icon);

      var answer = document.createElement('div');
      answer.className = 'faq-item__answer';

      var answerInner = document.createElement('div');
      answerInner.className = 'faq-item__answer-inner';
      answerInner.innerHTML = answerParts.join('');
      answer.appendChild(answerInner);

      button.addEventListener('click', function (btn, panel, wrapper) {
        return function () {
          var isOpen = wrapper.classList.contains('is-open');
          if (isOpen) {
            panel.style.maxHeight = '';
            wrapper.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            wrapper.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        };
      }(button, answer, item));

      item.appendChild(button);
      item.appendChild(answer);
      list.appendChild(item);
    }

    source.parentNode.replaceChild(list, source);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildAccordion);
  } else {
    buildAccordion();
  }
})();
